import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import { Controller } from 'react-hook-form'

export const InputRadioGroup = ({
  name,
  control,
  label,
  required = false,
  options,
}) => {
  return (
    <Controller
      rules={{ required: required ? 'Ce champ est obligatoire' : false }}
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <FormControl component="fieldset" error={!!error} sx={{ mb: 3 }}>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup value={value} onChange={onChange}>
              {options.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option.value}
                  label={option.label}
                  control={<Radio />}
                />
              ))}
            </RadioGroup>
          </FormControl>
        )
      }}
    />
  )
}
